(function () {
  const STORAGE_KEY = 'vatDisplay';
  const VAT_RATE = 0.21;

  const currency =
    window.themeVatConfig?.currency || 'EUR';

  const moneyFormatter = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: currency
  });

  const observedCardPrices = new WeakSet();

  let mainPriceObserver = null;
  let cardDiscoveryObserver = null;



  /* ---------------------------------------------
   * MODE
   * --------------------------------------------- */

  const params = new URLSearchParams(window.location.search);
  const urlVat = params.get('vat');

  if (urlVat === 'incl' || urlVat === 'excl') {
    try {
      localStorage.setItem(STORAGE_KEY, urlVat);
    } catch (e) {}
  }


  function getMode() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);

      if (saved === 'incl' || saved === 'excl') {
        return saved;
      }
    } catch (e) {}

    return 'excl';
  }


  function setMode(mode) {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {}
  }


  /* ---------------------------------------------
   * MONEY
   * --------------------------------------------- */

  function formatMoneyCents(cents) {
    const value = (cents || 0) / 100;

    try {
      return moneyFormatter.format(value);
    } catch (e) {
      return '€' + value.toFixed(2).replace('.', ',');
    }
  }


  function parseMoneyToCents(text) {
    if (!text) return null;

    let value = text
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '');

    // NL formaat:
    // 1.234,56 -> 1234.56
    if (value.includes(',')) {
      value = value
        .replace(/\./g, '')
        .replace(',', '.');
    }

    const number = parseFloat(value);

    if (Number.isNaN(number)) {
      return null;
    }

    return Math.round(number * 100);
  }


  function toModeCents(baseCents, mode) {
    if (
      typeof baseCents !== 'number' ||
      Number.isNaN(baseCents)
    ) {
      return 0;
    }

    return mode === 'incl'
      ? Math.round(baseCents * (1 + VAT_RATE))
      : baseCents;
  }


  function setPriceText(el, cents, mode) {
    if (!el || Number.isNaN(cents)) {
      return;
    }

    const formatted = formatMoneyCents(
      toModeCents(cents, mode)
    );

    if (el.textContent.trim() !== formatted) {
      el.textContent = formatted;
    }

    if (
      el.getAttribute('data-vat-rendered-text') !== formatted
    ) {
      el.setAttribute(
        'data-vat-rendered-text',
        formatted
      );
    }

    const ariaLabel =
      mode === 'incl'
        ? 'Prijs incl. btw'
        : 'Prijs excl. btw';

    if (el.getAttribute('aria-label') !== ariaLabel) {
      el.setAttribute('aria-label', ariaLabel);
    }
  }


  /* ---------------------------------------------
   * BODY / TOGGLES
   * --------------------------------------------- */

  function applyBodyClass(mode) {
    const html = document.documentElement;

    if (html.getAttribute('data-vat-mode') !== mode) {
      html.setAttribute('data-vat-mode', mode);
    }

    if (!document.body) {
      return;
    }

    document.body.classList.toggle(
      'btw-incl',
      mode === 'incl'
    );

    document.body.classList.toggle(
      'btw-excl',
      mode === 'excl'
    );
  }


  function syncSwitches(mode) {
    document
      .querySelectorAll('[data-btw-switch]')
      .forEach(function (checkbox) {
        const shouldBeChecked = mode === 'incl';

        if (checkbox.checked !== shouldBeChecked) {
          checkbox.checked = shouldBeChecked;
        }
      });
  }


  /* ---------------------------------------------
   * NORMALE SHOPIFY PRIJZEN
   * --------------------------------------------- */

  function updateBasePriceElement(el, mode) {
    if (!el) return;

    const base = parseInt(
      el.getAttribute('data-base-price-cents'),
      10
    );

    if (!Number.isNaN(base)) {
      setPriceText(el, base, mode);
    }

    const suffix =
      mode === 'incl'
        ? 'incl. btw'
        : 'excl. btw';

    if (
      el.getAttribute('data-vat-suffix') !== suffix
    ) {
      el.setAttribute(
        'data-vat-suffix',
        suffix
      );
    }
  }


  function updateAllBasePrices(mode) {
    document
      .querySelectorAll('[data-base-price-cents]')
      .forEach(function (el) {
        updateBasePriceElement(el, mode);
      });
  }


  /* ---------------------------------------------
   * HULK HOOFDPRIJS
   * --------------------------------------------- */

  function processMainProductPrice() {
    const container =
      document.querySelector('.product-info__price');

    if (!container) {
      return;
    }

    const mode = getMode();

    const currentEl = container.querySelector(
      '.price__default > .price__current'
    );

    const wasEl = container.querySelector(
      '.price__default > .price__was'
    );


    [currentEl, wasEl].forEach(function (el) {
      if (!el) return;

      const currentText = el.textContent.trim();

      if (!currentText) {
        return;
      }

      const lastVatText =
        el.getAttribute('data-vat-rendered-text');

      /*
       * Exact dezelfde tekst als ons script eerder
       * heeft geschreven: niets opnieuw capturen.
       */
      if (
        el.hasAttribute('data-base-price-cents') &&
        currentText === lastVatText
      ) {
        return;
      }

      /*
       * Tekst is anders geworden.
       * Dit is waarschijnlijk Hulk.
       */
      const cents =
        parseMoneyToCents(currentText);

      if (cents === null) {
        return;
      }

      el.setAttribute(
        'data-base-price-cents',
        cents
      );

      updateBasePriceElement(el, mode);
    });
  }


  function observeMainProductPrice() {
    const container =
      document.querySelector('.product-info__price');

    if (!container) {
      return;
    }

    if (mainPriceObserver) {
      mainPriceObserver.disconnect();
    }

    mainPriceObserver =
      new MutationObserver(function () {
        processMainProductPrice();
      });

    mainPriceObserver.observe(
      container,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );
  }


  /* ---------------------------------------------
   * PRODUCTCARDS
   * --------------------------------------------- */

  function restoreCardPrice(priceEl) {
    if (!priceEl) return;

    const mode = getMode();

    const basePrice = parseInt(
      priceEl.getAttribute(
        'data-shopify-price-cents'
      ),
      10
    );

    if (Number.isNaN(basePrice)) {
      return;
    }

    const comparePrice = parseInt(
      priceEl.getAttribute(
        'data-shopify-compare-price-cents'
      ),
      10
    );

    const currentEl =
      priceEl.querySelector(
        '.price__default > .price__current'
      );

    const wasEl =
      priceEl.querySelector(
        '.price__default > .price__was'
      );


    if (currentEl) {
      setPriceText(
        currentEl,
        basePrice,
        mode
      );
    }


    if (!wasEl) {
      return;
    }


    if (
      !Number.isNaN(comparePrice) &&
      comparePrice > basePrice
    ) {
      setPriceText(
        wasEl,
        comparePrice,
        mode
      );

      if (wasEl.hidden) {
        wasEl.hidden = false;
      }

      if (wasEl.style.display === 'none') {
        wasEl.style.display = '';
      }

    } else {

      if (wasEl.textContent !== '') {
        wasEl.textContent = '';
      }

      if (wasEl.style.display !== 'none') {
        wasEl.style.display = 'none';
      }
    }
  }


  function observeCardPrice(priceEl) {
    if (
      !priceEl ||
      observedCardPrices.has(priceEl)
    ) {
      return;
    }

    observedCardPrices.add(priceEl);

    restoreCardPrice(priceEl);

    const observer =
      new MutationObserver(function () {
        restoreCardPrice(priceEl);
      });

    observer.observe(
      priceEl,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );
  }


  function registerCardPrices(root) {
    if (!root) {
      return;
    }

    /*
     * Root kan zelf een prijs-element zijn.
     */
    if (
      root.matches &&
      root.matches(
        'product-card .price[data-shopify-price-cents], ' +
        '.card--related .price[data-shopify-price-cents]'
      )
    ) {
      observeCardPrice(root);
    }

    /*
     * Of nieuwe cards kunnen binnen root zitten.
     */
    if (root.querySelectorAll) {
      root
        .querySelectorAll(
          'product-card .price[data-shopify-price-cents], ' +
          '.card--related .price[data-shopify-price-cents]'
        )
        .forEach(observeCardPrice);
    }
  }


  function observeNewCards() {
    const main =
      document.querySelector('#main-content');

    if (!main) {
      return;
    }

    cardDiscoveryObserver =
      new MutationObserver(function (mutations) {

        mutations.forEach(function (mutation) {

          if (!mutation.addedNodes.length) {
            return;
          }

          mutation.addedNodes.forEach(function (node) {

            if (
              node.nodeType !== Node.ELEMENT_NODE
            ) {
              return;
            }

            /*
             * Alleen verder kijken als het toegevoegde
             * element mogelijk een relevante card bevat.
             */
            const isRelevant =
              node.matches?.(
                'product-card, .card--related, .price[data-shopify-price-cents]'
              ) ||
              node.querySelector?.(
                'product-card, .card--related'
              );

            if (!isRelevant) {
              return;
            }

            registerCardPrices(node);
          });
        });
      });

    cardDiscoveryObserver.observe(
      main,
      {
        childList: true,
        subtree: true
      }
    );
  }


  /* ---------------------------------------------
   * VOLLEDIGE BTW-WISSEL
   * --------------------------------------------- */

  function updateEverythingForMode() {
    const mode = getMode();

    applyBodyClass(mode);

    /*
     * Normale Shopify-prijzen.
     */
    updateAllBasePrices(mode);

    /*
     * Hulk-hoofdprijs.
     */
    processMainProductPrice();

    /*
     * Productcards.
     */
    document
      .querySelectorAll(
        'product-card .price[data-shopify-price-cents], ' +
        '.card--related .price[data-shopify-price-cents]'
      )
      .forEach(restoreCardPrice);

    syncSwitches(mode);
  }


  /* ---------------------------------------------
   * SWITCH EVENT
   * --------------------------------------------- */

  function initSwitches() {
    document.addEventListener(
      'change',
      function (event) {

        const target = event.target;

        if (
          !target ||
          !target.matches ||
          !target.matches('[data-btw-switch]')
        ) {
          return;
        }

        const mode =
          target.checked
            ? 'incl'
            : 'excl';

        setMode(mode);
        updateEverythingForMode();
      }
    );
  }


  /* ---------------------------------------------
   * INIT
   * --------------------------------------------- */

  function init() {
    const mode = getMode();

    applyBodyClass(mode);

    /*
     * Eenmalige initialisatie.
     */
    updateAllBasePrices(mode);

    registerCardPrices(document);

    processMainProductPrice();

    syncSwitches(mode);


    /*
     * Daarna uitsluitend gerichte observers.
     */
    observeMainProductPrice();
    observeNewCards();


    /*
     * Hulk initialiseert vaak iets later.
     * Geen full-page updates meer:
     * alleen de hoofdprijs opnieuw controleren.
     */
    setTimeout(
      processMainProductPrice,
      350
    );

    setTimeout(
      processMainProductPrice,
      1000
    );
  }


  initSwitches();


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

})();